import Schema from 'AppReact/schema';
import { makeReadyColumn } from 'types';

export default {
  isOpen: Schema('boolean', 'primitive', { defaultValue: false }),
  startMoveOutDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  startMoveInDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  endMoveOutDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  endMoveInDate: Schema('jsDate', 'primitive-nullable', { defaultValue: null }),
  selectedFloorplanIds: Schema('integer', 'array', { defaultValue: [] }),
  selectedTagIds: Schema('integer', 'array', { defaultValue: [] }),
  noTagIds: Schema('integer', 'array', { defaultValue: [] }),
  floorplans: Schema({}, 'array', { defaultValue: [] }),
  makeReadyCategories: Schema(makeReadyColumn, 'array', { defaultValue: [] }),
};
